export const FORM_NAME = 'FIELD_MAPPING_SIDEBAR_FORM';

// Basic text input types
export const INPUT_FIELD_TYPES = ['name', 'phone', 'email', 'string', 'text'] as const;

// Base field types for a person
export const BASE_PERSON_FIELD_NAMES = ['name', 'firstName', 'lastName', 'email', 'phone'] as const;

// Base field types for a company
export const BASE_COMPANY_FIELD_NAMES = ['name', 'phone'] as const;
